(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["text"] && !Shopify.designMode) return;
  try {
    class CollectionDescription extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('.collection-description__content');
      this.toggle = this.querySelector('.collection-description__toggle');
      this.showMore = this.querySelector('[data-show-more]');
      this.showLess = this.querySelector('[data-show-less]');

      if (!this.content || !this.toggle) return;

      this.toggle.addEventListener('click', this.handleToggle);
      this.resizeObserver = new ResizeObserver(this.update);
      this.resizeObserver.observe(this.content);
      this.update();
    }

    disconnectedCallback() {
      this.toggle?.removeEventListener('click', this.handleToggle);
      this.resizeObserver?.disconnect();
    }

    update = () => {
      const lineHeight = Number.parseFloat(getComputedStyle(this.content).lineHeight);
      if (!Number.isFinite(lineHeight)) return;

      const collapsedHeight = lineHeight * 2;
      this.content.style.setProperty('--collection-description-collapsed-height', `${collapsedHeight}px`);
      const overflows = this.content.scrollHeight > collapsedHeight + 1;

      this.toggle.hidden = !overflows;
      if (overflows && this.toggle.getAttribute('aria-expanded') === 'false') {
        this.content.setAttribute('data-collapsed', '');
      } else if (!overflows) {
        this.content.removeAttribute('data-collapsed');
      }
    };

    handleToggle = () => {
      const expanded = this.toggle.getAttribute('aria-expanded') === 'true';
      this.toggle.setAttribute('aria-expanded', String(!expanded));
      this.content.toggleAttribute('data-collapsed', expanded);
      this.showMore.hidden = !expanded;
      this.showLess.hidden = expanded;
    };
  }

  if (!customElements.get('collection-description')) {
    customElements.define('collection-description', CollectionDescription);
  }
  } catch(e) { console.error(e); }
})();

})();
